import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { io } from "socket.io-client";
import { Container, Button, Form, Image, Alert } from "react-bootstrap";
import { apiLoginColidee, apiVerifTokenColideeFlashCode } from "../../api/ApiAuthentification";
import { apiUpdateUserByIdColidee } from "../../api/ApiUser";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { chgToken } from "../../redux/ReduxToken";
import {
  chgEmail,
  chgPassword,
  chgNom,
  chgPrenom,
  chgPicture,
  chgIdColidee,
} from "../../redux/ReduxUser";
import ComponentLoader from "../../components/layout/ComponentLoader";
import ComponentError from "../../components/layout/ComponentError";
import logoEasyGouv from "../../assets/images/logoEasyGouv.png";
import QRCode from "react-qr-code";

import ComponentFooter from "../../components/layout/ComponentFooter";

const PageLogin = () => {
  const { t } = useTranslation();
  const [loader, setLoader] = useState(false);
  const [loaderFlashcode, setLoaderFlashcode] = useState(false);
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const { ReduxUserEmail, ReduxUserPassword } = useSelector((state) => state.ReduxUser);
  const dispatch = useDispatch();
  const [stayConnected, setStayConnected] = useState(true);
  const [flashCodeRoom, setFlashCodeRoom] = useState();
  const [regenereCode, setRegenereCode] = useState(false);

  /* Soumission du formulaire 
  Permet d'appeler l'API de vérif compte actif colidée avec son identifiant et son mot de passe */
  const loginWithColidee = async (e) => {
    e.preventDefault();
    setError(false);
    setLoader(true);
    const form = new FormData();
    form.append("email", ReduxUserEmail);
    form.append("password", ReduxUserPassword);
    const res = await apiLoginColidee(form);

    // souci de conne xion
    if (!res.status || res.status === 403) {
      setError(t("public.pageLogin.error"));
      setLoader(false);
      return;
    }

    /* on va regarder si le gars a un deviceToken afin de le mettre dans la collection user */
    const deviceTokenSauvegarde = localStorage.getItem("deviceToken");
    if (deviceTokenSauvegarde) {
      res.data.deviceToken = deviceTokenSauvegarde;
    }

    // Mise a jour de la table user mongoDB
    await apiUpdateUserByIdColidee(res.data.id, res.data);
    // se souvenir de moi et compte vérifié, on stocke le token en local storage et on continue vers le choix de l'instance
    if (stayConnected) {
      localStorage.setItem("token", res.data.token);
    }

    /* Mise à jour du token dans le REDUX pour s'en servir lors des requetes colidée */
    dispatch(chgToken(res.data.token));

    dispatch(chgNom(res.data.nom));
    dispatch(chgPrenom(res.data.prenom));
    dispatch(chgPicture(res.data.profile_pic));
    dispatch(chgIdColidee(res.data.id));
    // on met le password à null pour ne ps qu'il appraissen en clair dans le store
    dispatch(chgPassword(null));
    navigate("/choixInstance");
  };

  const loginWithFlashcode = async (token) => {
    const res = await apiVerifTokenColideeFlashCode(token);
    if (res.data) {
      dispatch(chgToken(res.data.token));
      dispatch(chgEmail(res.data.email));
      dispatch(chgNom(res.data.nom));
      dispatch(chgPrenom(res.data.prenom));
      dispatch(chgPicture(res.data.profile_pic));
      dispatch(chgIdColidee(res.data.id));
      navigate("/choixInstance");
    }
    setLoaderFlashcode(false);
    setRegenereCode(!regenereCode);
  };

  const toCreateAccount = () => {
    navigate("/createAccount");
  };

  /* Connexion au socketIO et initialisation de la room de discussion */
  useEffect(() => {
    const socket = io(process.env.REACT_APP_URL_SOCKETIO);
    /* le serveur IO ouvre une connexion et je rejoins la room qu'il me fournit */
    socket.on("openRoom", (laRoom, callback) => {
      socket.emit("joinRoom", laRoom);
      setFlashCodeRoom(window.location.href + "flashcodeVerif?room=" + laRoom);
    });

    /* la page de verif du flash code vient de nous tansmettre un token , on va vérifier si il est valide sur colidée pour permettre le process de login sur le terminal distant */
    socket.on("verifToken", (datas, callback) => {
      setLoaderFlashcode(true);
      loginWithFlashcode(datas.token);
      socket.disconnect();
    });
  }, [regenereCode]); // eslint-disable-line react-hooks/exhaustive-deps

  /* partie rendue  */
  return (
    <Container
      className="d-flex align-items-center justify-content-center"
      style={{ height: "100%" }}
    >
      {loader && <ComponentLoader />}
      {!loader && (
        <div className="text-center loginForm mt-5" style={{ width: "400px" }}>
          <Form onSubmit={loginWithColidee} className=" bg-primary  p-4 rounded">
            <div>
              <Image src={logoEasyGouv} className="mb-5" />
              <Form.Control
                type="email"
                value={ReduxUserEmail}
                placeholder={t("commun.form.placeholder.placeholderEmailConnexion")}
                onChange={(e) => {
                  setError();
                  dispatch(chgEmail(e.target.value));
                }}
                className="p-2 mb-3"
              />
              <Form.Control
                placeholder={t("commun.form.placeholder.placeholderMdpConnexion")}
                type="password"
                value={ReduxUserPassword}
                onChange={(e) => {
                  setError();
                  dispatch(chgPassword(e.target.value));
                }}
                className="p-2  mb-3"
              />
              <Form.Check
                type="checkbox"
                label={t("commun.form.placeholder.placeholderRemindMe")}
                id="stayConnected"
                name="stayConnected"
                className="p-2 mb-3"
                onChange={(e) => setStayConnected(!stayConnected)}
                checked={stayConnected ? "checked" : ""}
              />
              <Button type="Submit" className="bg-secondary text-dark mb-3">
                {t("commun.form.button.seConnecter")}
              </Button>
              <br />
              <span className="text-light" onClick={toCreateAccount} role="button">
                {t("commun.form.button.creerCompte")}
              </span>
            </div>
            {error && <ComponentError>{error}</ComponentError>}
          </Form>

          {flashCodeRoom && (
            <>
              {loaderFlashcode && <ComponentLoader />}
              {!loaderFlashcode && (
                <div className="flashCodeRoom mt-2">
                  <p>{t("public.pageLogin.flashCode")}</p>
                  <QRCode value={flashCodeRoom} className="m-2" size={200} />
                </div>
              )}
            </>
          )}
        </div>
      )}
      {/* <ComponentFooter /> */}
    </Container>
  );
};

export default PageLogin;
